import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EbEmployeeDashboardDetailsService } from '../../../service/eb-employee-dashboard-details/eb-employee-dashboard-details.service';
import { EbDashboardEmailType, LatestClaimStatus } from 'src/app/utility/enum/global-enum';
import { EbEmployeeDashboardVm } from '../../../model/eb-employee-dashboard-vm';
import { EbDashboardEmployeeBasicInfoVm } from '../../../model/eb-dashboard-employee-basic-info-vm';
import { EbDashboardLatestClaimsVm } from '../../../model/eb-dashboard-latest-claims-vm';
import { EbDashboardEmailService } from '../../../service/eb-dashboard-email/eb-dashboard-email.service';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { FileHandlerService } from 'src/app/utility/services/file-handler/file-handler.service';
import { DialogEnrolMedicalCardEmailComponent } from '../dialog-enrol-medical-card-email/dialog-enrol-medical-card-email.component';
import { MatDialog } from '@angular/material';
import { DialogClaimUsageEmailDiseaseDetailsComponent } from './dialog-claim-usage-email-disease-details/dialog-claim-usage-email-disease-details.component';
import { EBDashboardDiseaseVm } from '../../../model/eb-dashboard-disease-vm';
import { ClaimUsageEmailParamVm } from '../../../model/claim-usage-email-param-vm';

@Component({
  selector: 'app-eb-employee-dashboard-details',
  templateUrl: './eb-employee-dashboard-details.component.html',
  styleUrls: ['./eb-employee-dashboard-details.component.scss']
})
export class EbEmployeeDashboardDetailsComponent implements OnInit {

  LatestClaimStatus = LatestClaimStatus;
  dashboardData: EbEmployeeDashboardVm;
  diseaseVms: EBDashboardDiseaseVm[]
  employeeBasicInfo: EbDashboardEmployeeBasicInfoVm;
  employeeClaimDetails: EbDashboardLatestClaimsVm;
  messageList = [
    { title: "Members & Benefit Details", type: EbDashboardEmailType.MemberAndBenefitDetails, isAppear: true },
    { title: "Life Card", type: EbDashboardEmailType.LifeCard, isAppear: false },
    { title: "Medical Card", type: EbDashboardEmailType.MedicalCard, isAppear: true },
    { title: "Claim Usage", type: EbDashboardEmailType.ClaimUsage, isAppear: false }
  ];

  enrolId: number = null;
  isViewMoreEnabled: boolean = false;

  @Input() set setEnrolId(value) {
    if (value) {
      this.enrolId = value;
    }
  }
  @Output() onOtpSessionCancel = new EventEmitter<any>();

  showClaimDetails: boolean = false;

  constructor(
    private employeeDashboardDetailsService: EbEmployeeDashboardDetailsService,
    private ebDashboardEmailService: EbDashboardEmailService,
    private messageService: MessageService,
    private fileHandlerService: FileHandlerService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.getDashboardData();
    this.employeeDashboardDetailsService.isViewMoreSelectedChanges$.subscribe((res) => {
      this.showClaimDetails = res;
    })
  }

  getMessageList() {
    return this.messageList.filter(x => x.isAppear);
  }

  getDashboardData() {
    this.employeeDashboardDetailsService.getByEnrolId(this.enrolId).subscribe(
      (res: any) => {
        this.dashboardData = res;
        this.employeeBasicInfo = res.employeeBasicInfos;
        this.employeeClaimDetails = res.employeeClaimDetails;
        this.diseaseVms = res.diseaseVms;
        this.hasClaimUsageAndLifeCard(res.employeeBasicInfos[0].policyNumber);
      },
      error => {
        this.messageService.show(error.error.message, "error");
        this.onOtpSessionCancel.emit(true);
      }
    );
  }

  hasClaimUsageAndLifeCard(policyNumber: string) {
    this.employeeDashboardDetailsService.hasClaimUsageAndLifeCard(policyNumber).subscribe(
      (res: any) => {
        this.messageList.find(x => x.type == EbDashboardEmailType.LifeCard).isAppear = res.hasLifeCard;
        this.messageList.find(x => x.type == EbDashboardEmailType.ClaimUsage).isAppear = res.hasClaimUsage;
      },
      error => {
        this.messageService.show(error.error.message, "error");
      }
    );
  }

  sendEbDashboardEmail(type: EbDashboardEmailType) {
    if (type === EbDashboardEmailType.MemberAndBenefitDetails) {
      this.ebDashboardEmailService.sendMembersAndBenefitsEmail(this.enrolId).subscribe(
        (res: any) => {
          this.messageService.show(this.messageService.msgEmailSendSuccess, "success");
        },
        error => {
          this.messageService.show(error.error.message, "error");
        }
      )
    }
    else if (type === EbDashboardEmailType.MedicalCard) {
      this.openMemberSelectionDialog(this.enrolId);
    }
    else if (type === EbDashboardEmailType.LifeCard) {
      this.ebDashboardEmailService.sendEbDashboardLifeCardEmail(this.enrolId).subscribe(
        (res: any) => {
          this.messageService.show(this.messageService.msgEmailSendSuccess, "success");
        },
        error => {
          this.messageService.show(error.error.message, "error");
        }
      )
    }
    else if (type === EbDashboardEmailType.ClaimUsage) {
      this.sendClaimUsageEmail()
    }
  }

  toggleClaimDetails(isShowClaimDetails: boolean) {
    this.isViewMoreEnabled = isShowClaimDetails;
  }

  generateEbMedicalCardPdf = (enrolId: number): void => {
    this.ebDashboardEmailService.generateEbMedicalCardPdf(enrolId).subscribe(
      (res: any) => {
        this.fileHandlerService.downloadPdf(res, 'Medical Card.pdf');
        this.messageService.show("Medical Card generated successfully!", "success");
      },
      (err: any) => {
        this.messageService.show(err.error.message, "error");
      }
    );
  }

  openMemberSelectionDialog(enrolId: number) {
    this.employeeDashboardDetailsService.getAllActiveMembersByEnrolId(enrolId).subscribe((members: any[]) => {
      const dialogRef = this.dialog.open(DialogEnrolMedicalCardEmailComponent, {
        width: '300px',
        data: { members }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.sendMedicalCardEmail(result);
        }
      });
    },
      error => {
        this.messageService.show(error.error.message, 'error');
      });
  }

  sendMedicalCardEmail(member: any) {
    let enrolData = { enrolId: member.enrolId, enrolDependentId: member.enrolDependentId, isEnrol: member.isEnrol };
    this.ebDashboardEmailService.sendEbDashboardMedicalCardEmail(enrolData).subscribe(
      (res: any) => {
        this.messageService.show(this.messageService.msgEmailSendSuccess, 'success');
      },
      error => {
        this.messageService.show(error.error.message, 'error');
      }
    );
  }

  sendClaimUsageEmail() {
    if (this.diseaseVms.length) {
      this.openDialogClaimUsagePDFDetails()
    }
    else {
      const payload: ClaimUsageEmailParamVm = {
        enrolId: this.enrolId,
        iPDiseaseId: null,
        oPDiseaseId: null
      }
      this.ebDashboardEmailService.sendClaimUsageEmail(payload).subscribe(
        (res: any) => {
          this.messageService.show(this.messageService.msgEmailSendSuccess, "success");
        },
        error => {
          this.messageService.show(error.error.message, "error");
        }
      )
    }
  }

  openDialogClaimUsagePDFDetails() {
    const dialogRef = this.dialog.open(
      DialogClaimUsageEmailDiseaseDetailsComponent,
      {
        minWidth: '50%',
        data: {
          diseaseVms: this.diseaseVms,
          enrolId: this.enrolId
        },
        panelClass: 'custom-dialog-container'
      },
    );

    dialogRef.afterClosed().subscribe((result) => { });
  }

}
